import apiClient from '../apiClient';

// 요청 타입 정의
export type ReqGetBanner = {
  bannerType: 'MAIN' | 'MINI';
  exposePosition: 'BEST' | 'PLANNING' | 'COUPON' | 'HOME' | 'SPECIAL_DEAL';
  sizeType?: 'WEB' | 'MOBILE';
  detailPlatformType: 'MARKET' | 'TOUR';
};

// 응답 타입 정의
export type ResGetBanner = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: {
    id: number;
    mainTitle: string;
    subTitle: string;
    linkUrl: string;
    imageUrl: string;
    orderNumber: number;
  }[];
};

// API 호출 함수
export const getBanner = async ({
  bannerType,
  exposePosition,
  sizeType = 'WEB',
  detailPlatformType,
}: ReqGetBanner): Promise<ResGetBanner> => {
  // URLSearchParams를 사용하여 쿼리 문자열 생성
  const params = new URLSearchParams();
  params.append('bannerType', bannerType);
  params.append('exposePosition', exposePosition);
  params.append('sizeType', sizeType);
  params.append('detailPlatformType', detailPlatformType);
  // API 호출
  const { data } = await apiClient.get<ResGetBanner>(
    `/app/banners?${params.toString()}&platformType=GROUND`
  );

  return data;
};

export default getBanner;
